import apiClient from "../utils/apiClient";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useMyContext } from "../context";
import Swal from "sweetalert2";
import useFilter from "./useFilter";

const useRoles = () => {
  const queryClient = useQueryClient();
  const { search, page } = useFilter();
  const { roleData, handleCloseModal, showErrorAlert, id, setId } =
    useMyContext();
  const { data, error, isError, isLoading } = useQuery({
    queryKey: ["roles", page, search],
    queryFn: async () => {
      const res = await apiClient.get(
        `/dashboard/roles?search=${search}&page=${page}`,
      );
      return res.data;
    },
  });
  //   get permissions
  const {
    data: permissionData,
    error: permissionError,
    isError: permissionIsError,
    isLoading: permissionLoading,
  } = useQuery({
    queryKey: ["permissions"],
    queryFn: async () => {
      const res = await apiClient.get("/dashboard/permissions");
      return res.data;
    },
  });
  // add update role
  // add update role - combined function
  const addUpdateRole = useMutation({
    mutationFn: async () => {
      // Determine if we're creating or updating
      const isUpdate = !!id;

      if (isUpdate) {
        // Update existing role
        const res = await apiClient.put(`/dashboard/roles/${id}`, roleData);
        return res.data;
      } else {
        // Create new role
        const res = await apiClient.post("/dashboard/roles", roleData);
        return res.data;
      }
    },
    onSuccess: () => {
      const isUpdate = !!id;

      Swal.fire({
        icon: "success",
        title: isUpdate
          ? "Role updated successfully"
          : "Role created successfully",
        showConfirmButton: false,
        timer: 1500,
      });

      queryClient.invalidateQueries({ queryKey: ["roles"] });
      handleCloseModal("addEditRole");
      setId("");
    },
    onError: (err) => {
      showErrorAlert(err, "error");
    },
  });
  const addUpdateRoleLoading = addUpdateRole.isLoading;
  const handleAddUpdateRole = () => {
    addUpdateRole.mutate();
  };
  // get role by id
  const {
    data: roleDetails,
    error: roleDetailsError,
    isError: roleDetailsIsError,
    isLoading: roleDetailsLoading,
  } = useQuery({
    queryKey: ["roleDetails", id],
    queryFn: async () => {
      const res = await apiClient.get(`/dashboard/roles/${id}`);
      return res.data;
    },
    enabled: !!id,
  });
  // delete role
  const deleteRole = useMutation({
    mutationFn: async () => {
      const res = await apiClient.delete(`/dashboard/roles/${id}`);
      return res.data;
    },
    onSuccess: () => {
      Swal.fire({
        icon: "success",
        title: "Role deleted successfully",
        showConfirmButton: false,
        timer: 1500,
      });
      queryClient.invalidateQueries({ queryKey: ["roles"] });
      handleCloseModal("delete");
    },
    onError: (err) => {
      showErrorAlert(err, "error");
    },
  });
  const deleteRoleLoading = deleteRole.isLoading;
  const handleDeleteRole = () => {
    deleteRole.mutate();
  };
  return {
    data,
    error,
    isError,
    isLoading,
    permissionData,
    permissionError,
    permissionIsError,
    permissionLoading,
    addUpdateRoleLoading,
    handleAddUpdateRole,
    roleDetails,
    roleDetailsError,
    roleDetailsIsError,
    roleDetailsLoading,
    deleteRoleLoading,
    handleDeleteRole,
  };
};

export default useRoles;
